import { createSlice } from "@reduxjs/toolkit";
import { ICustomerAnalytics } from "../../models/admin/customerAnalytics/customerAnalytics";
import { getAllCustomerActivity, getAllCustomerActivityByDateRange } from "./CustomerAnalyticsActions";


const initialState: ICustomerAnalytics = {
    totalCount:0, 
    customerActivityGroup : {}
};

const customerAnalyticsSlice = createSlice({
  name: "conversationAnalysis",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
        getAllCustomerActivity.fulfilled,
      (state, { payload }) => {
        state.totalCount = payload?.data?.totalCount;
        state.customerActivityGroup = payload?.data?.customerActivityGroup;
      }
    );
    builder.addCase(
      getAllCustomerActivityByDateRange.fulfilled,
      (state, { payload }) => {
        state.totalCount = payload?.data?.totalCount;
        state.customerActivityGroup = payload?.data?.customerActivityGroup || {};
      }
    );
  },
});

export default customerAnalyticsSlice.reducer;
